import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiHeart, FiInstagram, FiFacebook, FiMail, FiSun } = FiIcons;

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-slate-100 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <SafeIcon icon={FiSun} className="text-2xl text-yellow-500" />
              <span className="font-black text-2xl text-[#5E3A21]">PETE & ROSEMARY</span>
            </div>
            <p className="text-slate-500 mb-6 max-w-xs italic text-sm leading-relaxed">
              Founders of "Where the Love Grows" – A mission dedicated to holistic healing and sharing the light with a broken world.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 rounded-full bg-slate-50 flex items-center justify-center text-[#5E3A21] hover:text-[#005b2d] hover:bg-green-50 transition-all border border-slate-100">
                <SafeIcon icon={FiInstagram} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-slate-50 flex items-center justify-center text-[#5E3A21] hover:text-[#005b2d] hover:bg-green-50 transition-all border border-slate-100">
                <SafeIcon icon={FiFacebook} />
              </a>
              <a href="mailto:neolife4life@gmail.com" className="w-10 h-10 rounded-full bg-slate-50 flex items-center justify-center text-[#5E3A21] hover:text-[#005b2d] hover:bg-green-50 transition-all border border-slate-100">
                <SafeIcon icon={FiMail} />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="font-bold text-[#5E3A21] mb-6 underline decoration-[#005b2d] decoration-4 underline-offset-8">Our World</h4>
            <ul className="space-y-4 font-medium">
              <li><a href="#story" className="text-slate-600 hover:text-[#005b2d] transition-colors">Our Mission</a></li>
              <li><a href="#products" className="text-slate-600 hover:text-[#005b2d] transition-colors">NeoLife Science</a></li>
              <li><a href="https://beta.neolife.com/peteandrosemary/en-US/enrollment" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-[#005b2d] transition-colors">Join the Team</a></li>
              <li><a href="https://beta.neolife.com/peteandrosemary/en-US" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-[#005b2d] transition-colors">Shop Official Site</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-[#5E3A21] mb-6 underline decoration-yellow-400 decoration-4 underline-offset-8">Health Promise</h4>
            <p className="text-xs text-slate-400 leading-relaxed uppercase tracking-wider">
              Independent NeoLife Distributors. These statements have not been evaluated by the FDA. Products are not intended to diagnose, treat, cure or prevent any disease.
            </p>
          </div>
        </div>
        
        <div className="border-t border-slate-100 pt-8 flex flex-col md:flex-row justify-between items-center text-[10px] sm:text-xs text-slate-400 font-bold uppercase tracking-widest">
          <p>&copy; {currentYear} Pete & Rosemary | Where the Love Grows</p>
          <p className="flex items-center gap-1">Built to share the light <SafeIcon icon={FiSun} className="text-yellow-500" /></p>
        </div>
      </div>
    </footer>
  );
}